import { render, staticRenderFns } from "./form.vue?vue&type=template&id=65abf94a&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=65abf94a&prod&scoped=true&lang=css"
import style1 from "./form.vue?vue&type=style&index=1&id=65abf94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abf94a",
  null
  
)

export default component.exports